var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5ZM8.25 11.25V12.75H9.75V11.25H8.25ZM9.75 10.0163C10.8343 9.6936 11.625 8.68912 11.625 7.5C11.625 6.05025 10.4497 4.875 9 4.875C7.7265 4.875 6.66478 5.78189 6.42548 6.9851L7.8966 7.27933C7.9992 6.76367 8.45422 6.375 9 6.375C9.6213 6.375 10.125 6.87868 10.125 7.5C10.125 8.1213 9.6213 8.625 9 8.625C8.58577 8.625 8.25 8.96077 8.25 9.375V10.5H9.75V10.0163Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.681e3f97651f69c4b7306f605e7bdb14.svg";
export { ForwardRef as ReactComponent };